import styled, { css } from 'styled-components';
import { Positions } from 'contracts/section';
import { fonts } from 'styles';

interface PositionProps {
  position?: Positions;
}

const getCssContainer = (position: Positions) => {
  switch (position) {
    case 'left':
      return css`
        flex-direction: row;
        @media screen and (max-width: 1000px) {
          flex-direction: column;
          padding: 0;
        }
      `;
    case 'right':
      return css`
        flex-direction: row-reverse;
        @media screen and (max-width: 1000px) {
          flex-direction: column;
          padding: 0;
        }
      `;
    case 'full':
      return css`
        flex-direction: column;
        padding: 0;
      `;
    default:
      return '';
  }
};

const getCssWrapper = (position: Positions) => {
  switch (position) {
    case 'left':
      return css`
        text-align: left;
        @media screen and (max-width: 1000px) {
          max-width: 100%;
        }
      `;
    case 'right':
      return css`
        text-align: right;
        @media screen and (max-width: 1000px) {
          text-align: left;
          max-width: 100%;
        }
      `;
    case 'full':
      return css`
        text-align: center;
        @media screen and (max-width: 1000px) {
          text-align: left;
          max-width: 100%;
        }
      `;
    default:
      return '';
  }
};

export const Container = styled.section<PositionProps>`
  width: 100%;
  margin: 0 auto;
  display: flex;
  padding: 4%;

  ${({ position }) => position && getCssContainer(position)}
`;

export const Content = styled.div<PositionProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 50%;

  &.text {
    padding: 48px;
  }

  ${({ position }) =>
    position === 'full' &&
    css`
      width: 100%;
    `}

  @media screen and (max-width: 1000px) {
    width: 100%;

    &.text {
      padding: 40px 32px 72px 32px;
    }
  }
`;

export const Photo = styled.img`
  width: 100%;
`;

export const Wrapper = styled.div<PositionProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 490px;

  ${({ position }) => position && getCssWrapper(position)}
`;

export const Title = styled.h2`
  font-family: ${fonts.BentonSansCompressedBold};
  font-size: 32px;
  line-height: 26px;
  text-transform: uppercase;
  margin-bottom: 40px;
`;

export const Text = styled.article`
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 16px;
`;

export const Legend = styled.div`
  font-size: 16px;
  line-height: 26px;
`;
